import jwtDecode from 'jwt-decode'
import store from '@/store.js'

export default (to, from, next) => {
  const token = store.getters.token

  if (token) {
    try {
      const decoded = jwtDecode(token)
      const now = Date.now().valueOf() / 1000

      if (typeof decoded.exp !== 'undefined' && decoded.exp < now) {
        //destroy invalid token
        store.dispatch('logout')
        next({ path: '/login' })
      } else {
        next()
      }
    } catch (err) {
      store.dispatch('logout')
      next({ path: '/login' })
    }
  } else {
    next({ path: '/login' })
  }
}